import { defineMessages } from 'react-intl';

export default defineMessages({
    reductionOfCoverage: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.reductionOfCoverage',
        defaultMessage: '28 - Reduction of Coverage when Vehicle Operated by Named Drivers',
    },
    reductionOfCoverage_AB_YT: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.reductionOfCoverage_AB_YT',
        defaultMessage: '28(C) - Named Person(s) Reduction of Coverage Endorsement',
    },
    reductionOfCoverage_ON: {
        id: 'wmic-pe-capability-gateway-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.reductionOfCoverage_ON',
        defaultMessage: 'OPCF 28 - Reducing Coverage for Named Persons',
    },
    excludedDriver: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.Excluded Driver',
        defaultMessage: '28A - Excluded Driver',
    },
});
